import { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import ModalComponent from "../../../components/Modal/Modal"
import SelfEnrollmentDebtFields from "./SelfEnrollmentDebtFields"
import { useMyContextLoading } from "../../../components/LoadingContextProvider/LoadingContextProvider"
import { showSnackBar } from "../../../components/Snackbar/Snackbar"
import { updateEnrollmentDebt } from "../../../features/selfEnrollment/selfEnrollment"
import { validateForm } from "../../Contacts/add-contact/CreditSelect/helper"

const buildFormFromCreditLine = (creditLine) => ({
  accountType: creditLine?.accountType?._id || creditLine?.accountType || "",
  accountNumber: creditLine?.accountNumber || "",
  openedDate: creditLine?.openedDate || null,
  reportedDate: creditLine?.reportedDate || null,
  closedDate: creditLine?.closedDate || null,
  lastPaymentDate: creditLine?.lastPaymentDate || null,
  accountStatus: creditLine?.accountStatus?._id || creditLine?.accountStatus || "",
  isOpenAccount: typeof creditLine?.isOpenAccount === 'boolean' ? creditLine.isOpenAccount : "",
  creditorName: creditLine?.creditorName || "",
  balanceAmount: creditLine?.balanceAmount ?? "",
  pastDueAmount: creditLine?.pastDueAmount ?? "",
  creditLimit: creditLine?.creditLimit ?? "",
})

const SelfEnrollmentUpdateDebtModal = ({
  open,
  setOpen,
  contactId,
  creditLine,
  creditReportTypes = [],
  creditReportStatuses = [],
}) => {
  const dispatch = useDispatch()
  const { triggerLoading } = useMyContextLoading()
  const [fields, setFields] = useState([buildFormFromCreditLine(creditLine)])
  const [errors, setErrors] = useState([])

  useEffect(() => {
    if (creditLine) {
      setFields([buildFormFromCreditLine(creditLine)])
    }
  }, [creditLine])

  useEffect(() => {
    validateForm({ fields, setErrors })
  }, [fields])

  const handleUpdate = async () => {
    if (!creditLine?._id || !contactId) return
    triggerLoading(true)
    const result = await dispatch(updateEnrollmentDebt({
      contactId,
      debtId: creditLine._id,
      data: fields[0],
    }))
    triggerLoading(false)

    if (updateEnrollmentDebt.fulfilled.match(result)) {
      showSnackBar("success", "The debt has been updated")
      setOpen(false)
    } else {
      showSnackBar("error", result.payload || "Failed to update debt")
    }
  }

  return (
    <ModalComponent
      modalButtonTitle="Update"
      buttonType="outlined"
      buttonTitleStyle="flex justify-center"
      title="Update Debt"
      functionButton={handleUpdate}
      customScroll={true}
      disabled={errors?.some((err) => Object.values(err || {}).some(Boolean))}
      disableBtn={false}
      customOpenModal={open}
      onClose={setOpen}
      modalWidth="w-[95vw] md:w-auto md:min-w-[680px] max-w-[1000px]"
    >
      <SelfEnrollmentDebtFields
        fields={fields}
        setFields={setFields}
        errors={errors}
        setErrors={setErrors}
        creditReportTypes={creditReportTypes}
        creditReportStatuses={creditReportStatuses}
        isUpdate={true}
      />
    </ModalComponent>
  )
}

export default SelfEnrollmentUpdateDebtModal
